import { useQuery } from '@tanstack/react-query';
import QUERY_KEYS from '../utils/QueryKeys';
import { Cart } from '../models';

export default function useCart(id) {
  // MUST fetch via the show endpoint (Cart.find). The index endpoint
  // (Cart.where({ id })) 404s for real customers -- Api::CartsController#index
  // requires filter[for_email] for non-admins -- so every consumer of this hook
  // silently got no cart outside admin sessions and offer auto-apply never ran
  // (found 2026-07-27 investigating the missing GRAD27 discount).
  return useQuery([QUERY_KEYS.CART, id], () => (
    Cart
      .find(id)
      .then((res) => res.data)
  ), { enabled: !!id });
}
